export default "__VITE_ASSET__CEQi94LI__"